export const getApiErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  const data = err?.response?.data;
  const detail = data?.detail;

  if (typeof detail === 'string') return detail;
  if (detail?.message) return detail.message;
  if (detail?.error) return detail.error;
  if (detail?.detail) return detail.detail;
  if (data?.message) return data.message;
  if (data?.error) return data.error;

  if (Array.isArray(detail) && detail.length) {
    return detail
      .map(item => item?.msg || item?.message)
      .filter(Boolean)
      .join(' ') || fallback;
  }

  if (!err?.response) {
    if (err?.message && err.message !== 'Network Error') return err.message;
    return 'We could not reach Magnolia right now. Please check your internet connection and try again.';
  }

  return fallback;
};
